/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Directory_TitleInputs */

const en_directory_integrate_directory_title = /** @type {(inputs: Directory_Integrate_Directory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the directory`)
};

const zh_directory_integrate_directory_title = /** @type {(inputs: Directory_Integrate_Directory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索目录`)
};

/**
* | output |
* | --- |
* | "Search the directory" |
*
* @param {Directory_Integrate_Directory_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_directory_title = /** @type {((inputs?: Directory_Integrate_Directory_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Directory_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_directory_title(inputs)
	return zh_directory_integrate_directory_title(inputs)
});
export { directory_integrate_directory_title as "directory.integrate.directory.title" }